export default "__VITE_ASSET__DJY3eOtQ__"